export const userPageStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: '20px',
    marginBottom: '20px',
  },
  headerTitle: {
    fontWeight: 'bold',
    fontSize: '20px',
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: { xs: '100%', sm: 'auto' },
    gap: '20px',
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    flex: 1,
    minHeight: 0,
    paddingBottom: '20px',
  },
  row: {
    width: '100%',
  },
  vehiclesRow: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  vehiclesCard: {
    borderRadius: '10px',
    padding: '10px 10px 0 10px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  vehiclesCardContent: {
    marginTop: '15px',
    paddingTop: 0,
    marginBottom: '15px',
    flex: 1,
    overflow: 'auto',
  },
  card: {
    borderRadius: '10px',
    padding: '10px 10px 0 10px',
    maxHeight: { xs: '30vh', sm: 'none' },
    overflow: { xs: 'auto', sm: 'visible' },
  },
  deleted: {
    'cursor': 'inherit',
    '&:hover': null,
    'background': 'rgba(165, 42, 42, 0.1)',
  },
  cardHeader: {
    paddingBottom: '0',
  },
  cardAction: {
    margin: '0 5px',
  },
  cardContent: {
    marginTop: '15px',
    paddingTop: 0,
    marginBottom: '15px',
  },
  image: {
    width: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
  detailsGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '15px',
    flexDirection: { xs: 'column', sm: 'row' },
  },
  detailBox: {
    display: 'flex',
    flexDirection: 'column',
  },
  detailTitle: {
    textTransform: 'uppercase',
    color: '#777',
    fontSize: '0.75rem',
    fontWeight: 'bolder',
  },
  detailValue: {
    fontWeight: 'bold',
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  },
  datePicker: {
    width: '100%',
  },
};
